/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/shared-ui/src/base/grid/css/grid';
import '@swisslife/patterns-base/src/atoms/logo/css/logo';
import '@swisslife/patterns-base/src/atoms/burger/css/burger';
import '@swisslife/patterns-base/src/molecules/search-box/css/search-box';
import '@swisslife/patterns-base/src/organisms/overlay/css/overlay';
import '../../../molecules/breadcrumb/css/breadcrumb';
import '../../../molecules/login/css/login';
import '../../../molecules/main-navigation/css/main-navigation';
import '../../../molecules/website-selector/css/website-selector';
import './header.scss';
import './modifier/mood-only.scss';
